/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/site';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const getAllProducers =
	(): Promise<ApiResponse> => {
		return apiClient.get('/producers', {
			params: {
				pageSize: 100,
				sort: 'name',
			},
		});
	};

/* -------------------------------------------------------------------------- */
/*                                     Hook                                   */
/* -------------------------------------------------------------------------- */
export const useAllProducers = () => {
	const { data, isFetching, isFetched, isPending } =
		useQuery({
			queryKey: ['all-producers'],
			queryFn: () => getAllProducers(),
		});

	return {
		data: data ? data?.rows : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
		isPending,
	};
};
